import React, { useMemo } from 'react';
import { Hint, Text } from '@common-fe/common-fe';

import { IAccountOrderDtoAccountTypeEnum, IOcrAccountOrderDtoAccountTypeEnum  } from '@/dtos';

const AccountTypeTitle: Record<IAccountOrderDtoAccountTypeEnum, string> = {
  [IAccountOrderDtoAccountTypeEnum.HSA]: 'Health Savings Account',
  [IAccountOrderDtoAccountTypeEnum.HCFSA]: 'Healthcare Flexible Spending Account',
  [IAccountOrderDtoAccountTypeEnum.HRA]: 'Health Reimbursement Arrangement',
  [IAccountOrderDtoAccountTypeEnum.DCAP]: 'Dependent Care Assistance Program',
  [IAccountOrderDtoAccountTypeEnum.EXTERNAL]: 'External',
  [IAccountOrderDtoAccountTypeEnum.CLEARING]: 'Clearing',
  [IAccountOrderDtoAccountTypeEnum.SUB_ACCOUNT]: 'Sub Account',
  [IAccountOrderDtoAccountTypeEnum.OMNIBUS]: 'Notional Omnibus',
  [IAccountOrderDtoAccountTypeEnum.PARKING]: 'Parking',
  [IAccountOrderDtoAccountTypeEnum.TRANSIT]: 'Transit',
  [IAccountOrderDtoAccountTypeEnum.ADOPTION]: 'Adoption',
  [IAccountOrderDtoAccountTypeEnum.SPECIALTY]: 'Specialty',
  [IAccountOrderDtoAccountTypeEnum.LIFESTYLE]: 'Lifestyle',
  [IAccountOrderDtoAccountTypeEnum.WAGEPARITY]: 'Wage Parity',
  [IAccountOrderDtoAccountTypeEnum.PLAN_OMNIBUS]: 'Plan Omnibus',
  [IAccountOrderDtoAccountTypeEnum.NOTIONAL_PAYROLL]: 'Notional Payroll',
  [IAccountOrderDtoAccountTypeEnum.NOTIONAL_FUNDING]: 'Notional Funding',
  [IAccountOrderDtoAccountTypeEnum.TRAVEL]: 'Travel',
};

enum OrderHintText {
  FIRST = 'this is the first account that will be used to pay for your expense.',
  SECOND = 'this account will be used to pay for your expense second, only if the first account (FSA) is exhausted.',
  NEXT = 'this account will be used to pay for your claim next, only if the previous accounts are exhausted.',
}

interface Props {
  order?: number;
  accountType?: IAccountOrderDtoAccountTypeEnum | IOcrAccountOrderDtoAccountTypeEnum;
}

const PaymentOrderBrickHint: React.FC<Props> = ({ order, accountType }) => {
  const accountTypeName = useMemo(() => accountType ? AccountTypeTitle[accountType] : accountType,
    [accountType]);
  
  const orderText = useMemo(() => {
    if (order === 1) {
      return OrderHintText.FIRST;
    }
    if (order === 2) {
      return OrderHintText.SECOND;
    }
    return OrderHintText.NEXT;
  }, [order]);

  if (!accountType) {
    return null;
  }

  return (
    <Hint testId="payment-order_brick" hintWidth={214}>
      <Text>
        <Text size="small" weight={700}>
          {(accountTypeName)}{': '}
        </Text>
        <Text size="small">
          {orderText}
        </Text>
      </Text>
    </Hint>
  );
};

export default PaymentOrderBrickHint;
